module.exports = __webpack_public_path__ + "static/media/RPFPC-Aurora-38.ec47d7a5.jpg";